import React from "react";
import { faBriefcase } from "@fortawesome/free-solid-svg-icons";

import Card from "../common/card";

import "./styles/works.css";

const Works = () => {
	return (
		<div className="works">
			<Card
				icon={faBriefcase}
				title="Work"
				body={
					<div className="works-body">
						<div className="work">
							<img
								src="./columbia.png"
								alt="columbia"
								className="work-image"
							/>
							<div className="work-title">Columbia University</div>
							<div className="work-subtitle">
								Graduate Student Researcher
							</div>
							<div className="work-duration">2018 - Present</div>
						</div>
					</div>
				}
			/>
		</div>
	);
};

export default Works;
